import { useGetPlantQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant.ts';
import PlantBreadcrumb from '@/features/plants/components/shared/plant-breadcrumb.tsx';
import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { Skeleton } from '@/components/ui/skeleton.tsx';
import PlantUptimeStatusPopover from '@/features/plants/components/plant-monitoring/plant-uptime-status-popover.tsx';
import PlantProductionOnlyOverview from '@/features/plants/components/plant-overview/production-only/plant-production-only-overview.tsx';
import { PlantMenuPopover } from '../plant-menu-popover';
import { PlantStatusBanner } from '../production-and-storage/plant-status-banner';

export const PlantProductionOnlyOverviewPage = ({
  plantId,
}: {
  plantId: string | undefined;
}) => {
  const { data: plant, isLoading: isPlantLoading } = useGetPlantQuery({
    plantId: plantId,
  });

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <PlantBreadcrumb plant={plant} />

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          {isPlantLoading ? (
            <Skeleton className="h-9 w-32" />
          ) : (
            <div className="flex w-full justify-between">
              <h2 className="text-2xl font-semibold">{plant?.basicDetails.name}</h2>
              <div className="flex items-center gap-2">
                <PlantUptimeStatusPopover />
                <PlantMenuPopover isLoading={isPlantLoading} />
              </div>
            </div>
          )}

          <PlantStatusBanner status={plant?.basicDetails.status} />
          <PlantProductionOnlyOverview plantId={plantId} isLoading={isPlantLoading} />
        </div>
      </div>
    </div>
  );
};

export default PlantProductionOnlyOverviewPage;
